module.exports = __webpack_public_path__ + "static/media/sg13tj0.c65ec18b.png";